import SubcategoryPage from '@/components/template/SubcategoryPage';

const SnakeTree = () => {
  const products = [
    {
      title: "Snake Tree Light",
      imageSrc: "https://images.unsplash.com/photo-1586798532888-f52f05e261ee?auto=format&fit=crop&q=80",
      url: "/proizvodi/snake-tree-light"
    },
    {
      title: "Snake Tree Dark",
      imageSrc: "https://images.unsplash.com/photo-1584458313453-5589fcbb6233?auto=format&fit=crop&q=80",
      url: "/proizvodi/snake-tree-dark"
    },
    {
      title: "Snake Tree Premium",
      imageSrc: "https://images.unsplash.com/photo-1586798532888-f52f05e261ee?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/snake-tree-premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Snake Tree"
      description="Inovativni Snake Tree obešalniki, ki združujejo skulpturalno estetiko in praktičnost."
      heroImage="https://images.unsplash.com/photo-1586798532888-f52f05e261ee?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default SnakeTree;